// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import { Slide } from 'vue-burger-menu';
import VueCollapse from 'vue2-collapse';
import VueMeta from 'vue-meta';

// Global include of our menu
Vue.component('Slide', Slide);
Vue.use(VueCollapse);
Vue.use(VueMeta);

Vue.config.productionTip = false;

// Styles
require("@/styles/main.css"); // For headers n' shit
require("@/styles/custom-burger-menu.css"); // Edit burger menu
require("@/styles/pure.min.css"); // Does grid etc.
require("@/styles/bootstrap4.min.css");
require("@/styles/semantic-ui/components/semantic-icon.min.css"); // Own folder due to dependencies
require("@/styles/semantic-ui/components/semantic-menu.min.css"); // Table sorting etc.

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: "<App/>"
})
